import React, {Component} from 'react';
// import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';
import {getAjax, isJson} from './../functions/functions.js';
import $ from "jquery";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class AuthTableMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            table_state: props.table_state
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            table_state: nextProps.table_state
        });
    }


    render() {
        if (!this.state.table_state.redis_data || !isJson(this.state.table_state.redis_data)) {
            return (null);
        }


        let data = JSON.parse(this.state.table_state.redis_data);
        let nr_of_conn = Object.keys(data).length;
        return (
            <div className="">
                Total number of connections: {nr_of_conn}
            </div>
        );
    }
}

class AuthenticatedDevices extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                // thisComponent.loadData(global.mainDomainName + '?get_ws_auth_connections&only_json', (component, data) => {
                thisComponent.loadData(global.mainDomainName + '?get_ws_auth_connections_detailed&only_json', (component, data) => {

                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    //

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    destroyAuthToken(token) {
        return () => {
            getAjax('?destroy_auth_token&only_json&token=' + token, (data) => {
                    let data_json = JSON.parse(data);
                    console.log(data_json);
                    if (data_json) {
                        toast("Token Destroyed!");
                    } else {
                        toast("Token doesnt exist or it's a server error!");
                    }
                },
                (e) => {

                },
            );
        }
    }

    enableDebugging(user_id) {
        return () => {
            getAjax('?enable_user_debugging&only_json&user_id=' + user_id, (data) => {
                    let data_json = JSON.parse(data);
                    console.log(data_json);
                    if (data_json) {
                        toast("Debugging Enabled!");
                    } else {
                        toast("Failed..Debugging was not enabled..");
                    }
                },
                (e) => {

                },
            );
        }
    }

    disableDebugging(user_id) {
        return () => {
            getAjax('?disable_user_debugging&only_json&user_id=' + user_id, (data) => {
                    let data_json = JSON.parse(data);
                    console.log(data_json);
                    if (data_json) {
                        toast("Debugging Disabled!");
                    } else {
                        toast("Failed..Debugging was not disabled..");
                    }
                },
                (e) => {

                },
            );
        }
    }

    generateTableRows() {
        {
            if (!this.state.redis_data || typeof this.state.redis_data !== 'object') {
                return (null);
            }
            // let data = JSON.parse(this.state.redis_data);
            // console.log("Generating table rows..");
            // console.log(data);
            // console.log(Object.values(data));


            return Object.entries(this.state.redis_data).map((value, i) => {
                // console.log(value);
                // console.log(value[0]);
                let k = value[0];
                let v = value[1];

                let connected_for = parseFloat((new Date().getTime() - new Date(v['auth_date']).getTime()) / 1000).toFixed(2);

                return (
                    <tr key={k}>
                        <td>{k}</td>
                        <td>{v['device_id']}</td>
                        <td>{v['auth_date']}</td>
                        <td>{v['device_unique_id']}</td>
                        <td>{v['user_id']}</td>
                        <td>{v['user_firstname']} {v['user_lastname']}</td>
                        <td>{v['device_name']}</td>
                        <td>{v['id']}</td>
                        <td>{connected_for} s</td>
                        <td>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                    Dropdown button
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a onClick={this.destroyAuthToken(v['id'])} className="dropdown-item" href="#">Remove
                                        Token</a>
                                    <a className="dropdown-item" href="#">UnAuthenticate</a>
                                    <a className="dropdown-item" href="#">Kill Connection</a>
                                    <a className="dropdown-item" href="#">Show Device Info</a>
                                    <a className="dropdown-item" href="#">Unauthorize</a>
                                    <a className="dropdown-item" href="#">Show cache info</a>
                                    <a onClick={this.enableDebugging(v['user_id'])} className="dropdown-item" href="#">Enable
                                        Debugging</a>
                                    <a onClick={this.disableDebugging(v['user_id'])} className="dropdown-item" href="#">Disable
                                        Debugging</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                );
            });
        }
    }


    noDataPreloader() {
        return (<PageLoader/>);
    }

    get_nr_of_conn() {
        let data = JSON.parse(this.state.redis_data);
        // console.log(data);
        // console.log('nr of conn: ' + data.length);
        return Object.keys(data).length;
    }

    render() {

        if (!this.state.redis_data) return this.noDataPreloader();
        // console.log('rendering...');

        // console.log('dwqdqwd', this.state.redis_data);


        return (
            <div>
                <AuthTableMenu table_state={this.state}/>
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col">Conn ID</th>
                        <th scope="col">Device ID</th>
                        <th scope="col">Auth Date</th>
                        <th scope="col">Unique ID</th>
                        <th scope="col">User ID</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Device Name</th>
                        <th scope="col">Token</th>
                        <th scope="col">Connected For</th>
                        <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.generateTableRows()}
                    </tbody>
                </table>
                <ToastContainer/>
            </div>
        );
    }
}

export default AuthenticatedDevices;



// WEBPACK FOOTER //
// ./src/components/AuthenticatedDevices.js